import React, { useEffect } from 'react';
import { PageLayout } from 'src/common/PageLayout';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useUser } from 'src/state/user';
import { storage } from '@uhg-abyss/web/tools/storage';

export const SuperUser = () => {
  const router = useRouter();
  const { uuid } = useUser.state();
  const { validateUser } = useUser.actions();
  const { validateUserSaga } = useUser.state();

  const handleRedirect = () => {
    router.navigate('/');
  };

  useEffect(() => {
    validateUser(
      (resp) => {
        storage.local.set(uuid, resp.active);
      },
      () => {}
    );
  }, []);

  return (
    <React.Fragment>
      <PageLayout>
        {!validateUserSaga.isLoading ? handleRedirect() : null}
      </PageLayout>
    </React.Fragment>
  );
};
